export default __webpack_public_path__ + "static/media/palette.74d2a4ce.svg";